module.exports = __webpack_public_path__ + "h5/img/t3.2fcf4b1d.jpg";